
import { Navigate } from "react-router-dom";
import { AdminDashboard } from "@/components/AdminDashboard";
import { useAuth } from "@/hooks/useAuth";
import { useLoginForm } from "@/hooks/useLoginForm";
import { useLoginRedirect } from "@/hooks/useLoginRedirect";
import { AccessDeniedCard } from "@/components/AreaPaciente/AccessDeniedCard";
import { LoadingScreen } from "@/components/AreaPaciente/LoadingScreen";
import { AreaPacienteLayout } from "@/components/AreaPaciente/AreaPacienteLayout";

export function AreaPacienteContent() {
  const { user, loading: authLoading, isAdmin } = useAuth();
  const {
    email,
    setEmail,
    password,
    setPassword,
    isLoading,
    justLoggedIn,
    setJustLoggedIn,
    handleSubmit
  } = useLoginForm();

  const { isAdminPanel } = useLoginRedirect({
    user,
    authLoading,
    justLoggedIn,
    isAdmin,
    setJustLoggedIn
  });

  // Rota /logins sem ?admin=true redireciona para o painel admin
  if (!isAdminPanel) {
    return <Navigate to="/logins?admin=true" replace />;
  }

  if (authLoading) {
    return <LoadingScreen />;
  }

  // Usuário logado como admin → painel
  if (user && isAdmin && !justLoggedIn) {
    return <AdminDashboard />;
  }

  // Usuário logado mas sem permissão
  if (user && !isAdmin && !justLoggedIn) {
    return <AccessDeniedCard />;
  }

  // Página de login do painel administrativo
  return (
    <AreaPacienteLayout
      isAdminPanel={true}
      showLoginForm={true}
      loginFormProps={{
        email,
        setEmail,
        password,
        setPassword,
        isLoading,
        onSubmit: handleSubmit
      }}
    />
  );
}
